import {
  create_shop_operation_target,
  update_shop_operation_target,
  query_shop_operation_target_list,
} from '@/api/mjstat-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstat/mjstat-shop_operation_target-config';

import { reactive } from 'vue';

const None = null;
const True = true;
const False = false;
import moment from 'moment';

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY);

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'monthpicker',
      name: 'date',
      label: '月份',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM',
      valueFormat: 'YYYY-MM-01',
      placeholder: '请选择月份',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '门店',
      disabled: false,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    date: moment().format('YYYY-MM-01'),
    shop_id: null,
    pageSize:2000,
  }),
};
const search_options = {};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 7,
    },
    wrapperCol: {
      span: 17,
    },
  },
  fields: [
    {
      type: 'monthpicker',
      name: 'date',
      label: '月份',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM',
      valueFormat: 'YYYY-MM-01',
      placeholder: '请选择月份',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '门店',
      disabled: !!current_shop,
      placeholder: '请选择门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'number',
      name: 'cz_target_count',
      label: '操作目标数',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写操作目标数',
    },
    {
      type: 'number',
      name: 'hl_target_amount',
      label: '护理目标金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写护理目标金额',
    },
    {
      type: 'number',
      name: 'cp_target_amount',
      label: '产品目标金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写产品目标金额',
    },
  ],
  rules: {
    date: [{ required: true, message: '请选择月份' }],
    shop_id: [{ required: true, message: '请选择门店' }],
    cz_target_count: [{ required: true, message: '请填写操作目标数' }],
    hl_target_amount: [{ required: true, message: '请填写护理目标金额' }],
    cp_target_amount: [{ required: true, message: '请填写产品目标金额' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    date: null,
    cz_target_count: null,
    hl_target_amount: null,
    cp_target_amount: null,
    shop_id: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 7,
    },
    wrapperCol: {
      span: 17,
    },
  },
  fields: [
    {
      type: 'monthpicker',
      name: 'date',
      label: '月份',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM',
      valueFormat: 'YYYY-MM-01',
      placeholder: '请选择月份',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '门店',
      disabled: !!current_shop,
      placeholder: '请选择门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'number',
      name: 'cz_target_count',
      label: '操作目标数',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写操作目标数',
    },
    {
      type: 'number',
      name: 'hl_target_amount',
      label: '护理目标金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写护理目标金额',
    },
    {
      type: 'number',
      name: 'cp_target_amount',
      label: '产品目标金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写产品目标金额',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    date: null,
    cz_target_count: null,
    hl_target_amount: null,
    cp_target_amount: null,
    shop_id: null,
    shop_operation_target_id: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '店务运营目标',
  addModalTitle: '新建店务运营目标',
  updateTitle: '编辑店务运营目标',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    shop_operation_target_id: 'id',
  },
  delete: {
    shop_operation_target_id: 'id',
  },
  recover: {
    shop_operation_target_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    shop_operation_target_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '月份',
    dataIndex: 'date',
    width: 100,
  },
  {
    title: '门店编码',
    width: 120,
    dataIndex: 'shop__code',
    checked: true,
  },
  {
    title: '门店名称',
    width: 120,
    dataIndex: 'shop__name',
    checked: true,
  },
  {
    title: '操作目标数',
    width: 120,
    dataIndex: 'cz_target_count',
    checked: true,
  },
  {
    title: '护理目标金额',
    width: 120,
    dataIndex: 'hl_target_amount',
    checked: true,
  },
  {
    title: '操作',
    width: 80,
    dataIndex: 'action',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
// newSlotList.push({
//   type: 'custom',
//   // slotName: 'is_active',
//   field_true: '可用',
//   field_false: '作废',
// });

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_shop_operation_target_list,
    addData: create_shop_operation_target,
    updateData: update_shop_operation_target,
    removeData: null,
    recoverData: null,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
